import { render, staticRenderFns } from "./noorplay_Footer.vue?vue&type=template&id=455fb87c&scoped=true&"
import script from "./noorplay_Footer.vue?vue&type=script&lang=js&"
export * from "./noorplay_Footer.vue?vue&type=script&lang=js&"
import style0 from "./noorplay_Footer.vue?vue&type=style&index=0&id=455fb87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fb87c",
  null
  
)

export default component.exports